module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Permissions owner</th>\r\n        ';
 if (showOrganization == true) { 
__p+='\r\n        <th>Organization</th>\r\n        ';
 } 
__p+='\r\n        <th>Can View</th>\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <th>Can Read All</th>\r\n        ';
 } 
__p+='\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <th>Can Read For</th>\r\n        ';
 } 
__p+='\r\n        <th>Can Edit</th>\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <th>Can Edit For</th>\r\n        ';
 } 
__p+='\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <th>Can Edit All</th>\r\n        ';
 } 
__p+='\r\n        <th>Can Delete</th>\r\n        <th>Can Sign</th>\r\n        ';
 if (showOrganization == true && permittedObjectType != 'document') { 
__p+='\r\n        <th>Can Sign For All</th>\r\n        ';
 } 
__p+='\r\n        ';
 if (permittedObjectType != 'document') { 
__p+='\r\n        <th>Can Upload For</th>\r\n        ';
 } 
__p+='\r\n        <th>Can Change Reviewer</th>\r\n        <th>Delete</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n<div id="yes-no-confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/permissions/permissions-table.html
// module id = 240
// module chunks = 0